/**
 * One order may carry at most this many packages, and packages cannot be combined across orders.
 *
 * From the legacy 提交运单 page, which states it in a red paragraph you read after the fact. Here
 * it stops the selection instead.
 *
 * TODO(MYP-13): confirm whether "no combine service" also means one order cannot mix warehouses.
 * If it does, this screen needs to show which warehouse each package is in — it currently does
 * not, because the design does not.
 *
 * The only survivor of this file's MYP-53-slice-1 self: packages, channels, order services and
 * destinations are all live now (`OrderCatalogProvider`, `usePackages`), and this cap is the one
 * thing among them that was never a stand-in for a wire shape — it's a rule the design chose, not
 * a fact the vendor reports.
 */
export const MAX_PACKAGES_PER_ORDER = 50;
